<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-h"><span>Author’s note</span></p>
<p class="normala"><i>Kaleidoscope</i> is a work of fiction. Though I have used actual places and times, I have treated these as I saw fit, changing some as appropriate. Occasionally the name of a real person is also used for historical authenticity, but all are deceased and I have made of them what the story demands. I do not condone what happened during these times. Indeed, I abhor it. But during the Occupation of France the everyday crimes of murder and arson continued to be committed, and I merely ask, By whom and how were they solved?</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Authors.vue?2dc8dfa7